import React from 'react';
import { Bar } from 'react-chartjs-2';
import 'chart.js/auto';

const TrendAnalysisChart = ({ trendData, trendColumns }) => {
    if (!trendData || !trendColumns || trendColumns.length === 0 || Object.keys(trendData).length <= 1) { // Also check if trendData has more than just 'Total'
        return null; // Don't render anything if there's no data
    }

    // X-axis labels (e.g., ['T-Mobile_Android', 'T-Mobile_iOS'])
    const labels = trendColumns.filter(col => col !== 'Total');

    // Categories for stacking (e.g., ['All Normal', 'Improved', ...])
    const categories = Object.keys(trendData).filter(key => key !== 'Total' && key !== 'No Data');

    // Define colors for each category
    const categoryColors = {
        'All Normal': '#34A853', // Green
        'Improved': '#4285F4',   // Blue
        'Declined': '#FBBC05',   // Yellow/Orange
        'Mult Spam': '#EA4335',  // Red
        'Mult Unknown': '#A9A9A9', // Grey
    };

    const datasets = categories.map(category => {
        return {
            label: category,
            data: labels.map(label => trendData[category]?.[label] || 0),
            backgroundColor: categoryColors[category] || '#CCCCCC', // Default color
        };
    });

    const chartData = {
        labels: labels.map(l => l.replace(/_/g, ' ')), // Make labels more readable
        datasets: datasets,
    };

    const isSingleBar = labels.length === 1;

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: 'top',
            },
            title: {
                display: true,
                text: 'Summary Comparison by Carrier/Platform',
                font: {
                    size: 16,
                },
            },
            tooltip: {
                mode: 'index',
                intersect: false,
            },
        },
        scales: {
            x: {
                stacked: true,
                title: {
                    display: true,
                    text: 'Carrier / Platform',
                },
            },
            y: {
                stacked: true,
                title: {
                    display: true,
                    text: 'Number Count',
                },
                beginAtZero: true,
                ticks: {
                    precision: 0,
                },
            },
        },
        barThickness: isSingleBar ? 80 : undefined,
    };

    return (
        // <div className="common-white-shadow-background setting-section" style={{ marginTop: '20px' }}>
            <div style={{ height: '400px', width: '100%' }}>
                <Bar data={chartData} options={options} />
            </div>
        // </div>
    );
};

export default TrendAnalysisChart;

